<template>
    <div>
        <keep-alive>
            <component :is="currentPage" />
        </keep-alive>
    </div>
</template>

<script type="module">
export default {
   name: 'FinancialIndicator',
   components: {
     fgroups,
     hgroups,
     end,
     visualization
   }
}
</script>

<script setup>
import fgroups from './bar_and_line/federal_groups.vue'
import hgroups from './bar_and_line/hospital_groups.vue'
import end from './bar_and_line/end.vue'
import visualization from './bar_and_line/visualization.vue'

import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../stores/vis_store'

const {  loadPages, loadPage, nextPage, previousPage, setUser, setChartType, setYears, setDefaultYear, fetchIndicators, setIndicator } = useVisualizationsStore()

const {   response, currentPage, pages, loading, arrindicators, user, charttype , defaultyear} = storeToRefs(useVisualizationsStore())
const props = defineProps([  'currentPage', 'user', 'chartType', 'years', 'defaultYear'])
//console.log(props);
var store = useVisualizationsStore()


loadPages({
     'hgroups': hgroups,
     'fgroups': fgroups,
     'end': end,
     'visualization': visualization,
    })



setUser(props.user);
setChartType(props.chartType);
setYears(props.years);
setDefaultYear(props.defaultYear);

fetchIndicators();


watch(arrindicators, async () => {
    if ( arrindicators.length !== 0 ) {
        const arrInd = store.arrindicators;
        var fdi_indicator = null;
        arrInd.forEach( (ind) => {
            console.log(ind)
            if (ind.indicator == 'fdicat') {
                fdi_indicator = ind;
            }
        });
        setIndicator(fdi_indicator);
    }
  
})


</script>